import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL, getCachedSessionId } from '../../services/common';
import { useNotification } from '../../providers/notificationsProvider';

const fetchAccounts = async (projectId) => {
  const response = await axios.get(`${API_URL}/v1/project/${projectId}/provider/hosting/cpanel/`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });

  return response.data;
};

export const useAccounts = (projectId) => {
  const { notify } = useNotification();
  return useQuery(['cPanel', projectId], () => fetchAccounts(projectId), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
